import React, { useState, useEffect } from 'react';
import { displayMessage } from '../Utils/helper';
import { stageLayoutStyles, stageFormStyles } from '../components/createworkflow/helper';
import PageHeader from '../components/common/PageHeader';

const STORAGE_KEY = 'scm_management';
const emptyForm = { name: '', mail: '', role: '' };
const FIELDS = [
  { name: 'name', label: 'Name', type: 'text', placeholder: 'Enter name' },
  { name: 'mail', label: 'Mail', type: 'email', placeholder: 'Enter email address' },
  { name: 'role', label: 'Role', type: 'text', placeholder: 'Enter role' },
];

const readLocal = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
};

const pageStyles = {
  wrapper: {
    width: '100%',
    boxSizing: 'border-box',
    background: '#f4f3ef',
  },
  card: {
    ...stageLayoutStyles.card,
    marginBottom: 14,
  },
  cardTitle: {
    ...stageFormStyles.sectionTitle,
    marginBottom: 12,
    paddingBottom: 10,
    borderBottom: '1px solid #e6eef4',
  },
  formRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 14,
    alignItems: 'flex-end',
  },
  formField: {
    flex: '1 1 200px',
    minWidth: 0,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    alignItems: 'center',
  },
  primaryBtn: {
    padding: '8px 18px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'Poppins, sans-serif',
    color: '#fff',
    background: '#E06639',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    boxShadow: '0 3px 10px rgba(224, 102, 57, 0.25)',
    transition: 'background 0.15s ease',
    whiteSpace: 'nowrap',
  },
  primaryBtnDisabled: {
    background: '#9ca3af',
    cursor: 'not-allowed',
    boxShadow: 'none',
  },
  outlineBtn: {
    padding: '7px 16px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'Poppins, sans-serif',
    color: '#032B4E',
    background: '#fff',
    border: '1.5px solid #032B4E',
    borderRadius: 8,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  dangerOutlineBtn: {
    padding: '7px 16px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'Poppins, sans-serif',
    color: '#b91c1c',
    background: '#fff',
    border: '1.5px solid #dc2626',
    borderRadius: 8,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  dangerBtn: {
    padding: '8px 18px',
    fontSize: 13,
    fontWeight: 600,
    fontFamily: 'Poppins, sans-serif',
    color: '#fff',
    background: '#b91c1c',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  secondaryBtn: {
    display: 'inline-block',
    padding: '7px 14px',
    fontSize: 12,
    fontWeight: 700,
    fontFamily: 'Poppins, sans-serif',
    color: '#fff',
    background: '#c9552a',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(201, 85, 42, 0.28)',
    whiteSpace: 'nowrap',
    lineHeight: 1.2,
  },
  tableWrap: {
    width: '100%',
    overflowX: 'auto',
    borderRadius: 12,
    border: '1px solid #e6eef4',
    boxShadow: '0 3px 12px rgba(12, 60, 84, 0.06)',
    background: '#fff',
  },
  table: {
    width: '100%',
    minWidth: 640,
    borderCollapse: 'collapse',
    fontFamily: 'Poppins, sans-serif',
  },
  th: {
    background: '#032B4E',
    color: '#fff',
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 700,
    textAlign: 'center',
    borderRight: '1px solid rgba(255,255,255,0.1)',
    whiteSpace: 'nowrap',
  },
  thLast: {
    background: '#032B4E',
    color: '#fff',
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 700,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 500,
    color: '#0c3c54',
    borderBottom: '1px solid #e6eef4',
    borderRight: '1px solid #e6eef4',
    verticalAlign: 'middle',
    textAlign: 'left',
  },
  tdMuted: {
    padding: '12px 16px',
    fontSize: 13,
    fontWeight: 500,
    color: '#6a7d8c',
    borderBottom: '1px solid #e6eef4',
    borderRight: '1px solid #e6eef4',
    verticalAlign: 'middle',
    textAlign: 'left',
  },
  tdCenter: {
    padding: '12px 16px',
    fontSize: 13,
    color: '#0c3c54',
    borderBottom: '1px solid #e6eef4',
    textAlign: 'center',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
  },
  rowActive: {
    background: '#f8fbfd',
  },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #021a30 0%, #032B4E 100%)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 13,
    fontWeight: 600,
    flexShrink: 0,
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  nameText: {
    fontSize: 13,
    fontWeight: 600,
    color: '#0c3c54',
    fontFamily: 'Poppins, sans-serif',
  },
  pill: {
    display: 'inline-block',
    background: '#eff7fc',
    color: '#032B4E',
    padding: '2px 10px',
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
    border: '1px solid #c4e0f0',
  },
  emptyText: {
    textAlign: 'center',
    padding: '32px 16px',
    fontSize: 13,
    color: '#6a7d8c',
    fontFamily: 'Poppins, sans-serif',
  },
  modalOverlay: {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(2, 26, 48, 0.55)',
    zIndex: 10000,
  },
  modal: {
    width: '92%',
    maxWidth: 440,
    background: '#fff',
    borderRadius: 12,
    overflow: 'hidden',
    border: '1px solid #e6eef4',
    boxShadow: '0 16px 40px rgba(12, 60, 84, 0.2)',
  },
  modalHead: {
    background: '#032B4E',
    color: '#fff',
    padding: '14px 18px',
    font: '600 16px Poppins, sans-serif',
  },
  modalBody: {
    padding: 20,
  },
  modalText: {
    margin: '0 0 8px',
    font: '500 14px Poppins, sans-serif',
    color: '#0c3c54',
  },
  modalHint: {
    margin: '0 0 20px',
    font: '400 13px Poppins, sans-serif',
    color: '#6a7d8c',
  },
};

export default function ManagementPage() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setList(readLocal());
    /* TODO backend: GET /scm/management */
  }, []);

  const editing = list.find((el) => el.mgmt_id === editingId);

  const resetForm = () => {
    setForm(emptyForm);
    setEditingId(null);
    setShowDelete(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEdit = (person) => {
    setEditingId(person.mgmt_id);
    setShowDelete(false);
    setForm({ name: person.name || '', mail: person.mail || '', role: person.role || '' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = () => {
    if (editingId == null) return;
    const next = list.filter((el) => el.mgmt_id !== editingId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    setList(next);
    resetForm();
    /* TODO backend: DELETE /scm/management/:id */
    displayMessage('success', 'Success', 'Management person deleted successfully.');
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const name = form.name.trim();
    const mail = form.mail.trim();
    const role = form.role.trim();
    const isEditing = editingId != null;

    if (!name || !mail || !role) {
      displayMessage('danger', 'Invalid Input', 'Name, mail and role are all required.');
      return;
    }
    if (list.some((el) => el.mail?.toLowerCase() === mail.toLowerCase() && el.mgmt_id !== editingId)) {
      displayMessage('danger', 'Duplicate Entry', `${mail} is already in the management list.`);
      return;
    }

    setLoading(true);
    try {
      const next = isEditing
        ? list.map((el) => (el.mgmt_id === editingId ? { ...el, name, mail, role } : el))
        : [...list, { mgmt_id: Date.now(), name, mail, role }];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      setList(next);
      /* TODO backend: POST /scm/management · PUT /scm/management/:id */
      resetForm();
      displayMessage(
        'success',
        'Success',
        isEditing ? 'Management person updated successfully.' : 'Management person added successfully.'
      );
    } catch (err) {
      console.error(err);
      displayMessage(
        'danger',
        'Error',
        isEditing ? 'Error updating management person.' : 'Error adding management person.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mgmt-config-page" style={pageStyles.wrapper}>
      <style>{pageCss}</style>
      <PageHeader
        title="Management"
        subtitle="Add management members and view everyone currently on record."
      />

      <div style={pageStyles.card}>
        <h2 style={pageStyles.cardTitle}>
          {editingId != null ? 'Edit Management Person' : 'Add Management Person'}
        </h2>
        <form onSubmit={handleSave}>
          <div style={pageStyles.formRow}>
            {FIELDS.map((f) => (
              <div key={f.name} style={pageStyles.formField}>
                <label style={stageFormStyles.label}>{f.label}</label>
                <input
                  type={f.type}
                  name={f.name}
                  placeholder={f.placeholder}
                  value={form[f.name]}
                  onChange={handleChange}
                  required
                  style={stageFormStyles.input}
                />
              </div>
            ))}
            <div style={pageStyles.actions}>
              {editingId != null && (
                <>
                  <button
                    type="button"
                    style={pageStyles.dangerOutlineBtn}
                    onClick={() => setShowDelete(true)}
                    disabled={loading}
                  >
                    Delete
                  </button>
                  <button
                    type="button"
                    style={pageStyles.outlineBtn}
                    onClick={resetForm}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </>
              )}
              <button
                type="submit"
                disabled={loading}
                style={{
                  ...pageStyles.primaryBtn,
                  ...(loading ? pageStyles.primaryBtnDisabled : {}),
                }}
              >
                {loading ? 'Saving...' : editingId != null ? 'Update' : 'Save'}
              </button>
            </div>
          </div>
        </form>
      </div>

      <div style={pageStyles.card}>
        <h2 style={pageStyles.cardTitle}>Management Directory</h2>
        <div style={pageStyles.tableWrap}>
          <table style={pageStyles.table}>
            <thead>
              <tr>
                <th style={pageStyles.th}>Name</th>
                <th style={pageStyles.th}>Mail</th>
                <th style={pageStyles.th}>Role</th>
                <th style={pageStyles.thLast}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {list.length > 0 ? (
                list.map((elem) => (
                  <tr
                    key={elem.mgmt_id}
                    style={editingId === elem.mgmt_id ? pageStyles.rowActive : undefined}
                  >
                    <td style={pageStyles.td}>
                      <div style={pageStyles.nameCell}>
                        <div style={pageStyles.avatar}>
                          {elem.name?.charAt(0)?.toUpperCase()}
                        </div>
                        <span style={pageStyles.nameText}>{elem.name}</span>
                      </div>
                    </td>
                    <td style={pageStyles.tdMuted}>{elem.mail}</td>
                    <td style={{ ...pageStyles.td, textAlign: 'center' }}>
                      <span style={pageStyles.pill}>{elem.role}</span>
                    </td>
                    <td style={pageStyles.tdCenter}>
                      <button
                        type="button"
                        style={pageStyles.secondaryBtn}
                        onClick={() => handleEdit(elem)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={pageStyles.emptyText}>
                    No management members found. Add your first entry above.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showDelete && editing && (
        <div style={pageStyles.modalOverlay} onClick={() => setShowDelete(false)}>
          <div style={pageStyles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={pageStyles.modalHead}>Delete Management Person</div>
            <div style={pageStyles.modalBody}>
              <p style={pageStyles.modalText}>
                Are you sure you want to delete <strong>{editing.name}</strong>?
              </p>
              <p style={pageStyles.modalHint}>This action cannot be undone.</p>
              <div style={{ ...pageStyles.actions, justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  style={pageStyles.outlineBtn}
                  onClick={() => setShowDelete(false)}
                >
                  Cancel
                </button>
                <button type="button" style={pageStyles.dangerBtn} onClick={handleDelete}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const pageCss = `
  .mgmt-config-page label {
    font-family: Poppins, sans-serif !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    color: #0c3c54 !important;
    margin-bottom: 8px !important;
    text-transform: none !important;
  }

  .mgmt-config-page input {
    font-family: Poppins, sans-serif !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #0c3c54 !important;
  }

  .mgmt-config-page input::placeholder {
    font-family: Poppins, sans-serif !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    color: #6a7d8c !important;
  }
`;
